import { getDefaultClient } from '@dynamic-labs-sdk/client';
import { getWalletProviderFromWalletAccount } from '@dynamic-labs-sdk/client/core';

import type { BitcoinWalletAccount } from '../BitcoinWalletAccount.types';
import type { BitcoinSignPsbtRequest } from '../BitcoinWalletProvider.types';
import { NotBitcoinProviderError } from '../errors/NotBitcoinProviderError';
import { isBitcoinWalletProvider } from '../isBitcoinWalletProvider';

type SignPsbtsParams = {
  requests: BitcoinSignPsbtRequest[];
  walletAccount: BitcoinWalletAccount;
};

/**
 * Signs multiple PSBTs
 * @param params.requests - The list of request data to sign the PSBTs
 * @param params.walletAccount - The wallet account to sign the PSBT with
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns An object containing the signed PSBT
 */
export const signPsbts = async (
  { walletAccount, requests }: SignPsbtsParams,
  client = getDefaultClient()
): Promise<{ signedPsbts: string[] }> => {
  const provider = getWalletProviderFromWalletAccount(
    {
      walletAccount,
    },
    client
  );

  if (!isBitcoinWalletProvider(provider)) {
    throw new NotBitcoinProviderError({ providerKey: provider.key });
  }

  return provider.signPsbts({ requests, walletAccount });
};
